import { render, staticRenderFns } from "./VehicleModal.vue?vue&type=template&id=c4d6bd5a"
import script from "./VehicleModal.vue?vue&type=script&lang=ts"
export * from "./VehicleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports